const configData = {
  dev: {
    stripePublicKey:
      "pk_test_51KS4vmJhiOaVjc8SoLQMswWBQMX1PprxACRBLlFJdN7ZoSBFtth2iXaQFzSH1CC8zHrcxmr1TwfPEGLxxL4KaCo900xuEY7uxw",
    baseApiUrl: "https://dev-api.myprotectall.com/post_sale_marketing/v1",
    stripeCheckoutApi: "/stripe_checkout",
    getOfferDetail: "/get_temp_cred",
    declineCoverage: "/user_opt_out",
    saveActivity: "/save_activity",
    getSecret: "/get-secret",
  },
  prod: {
    stripePublicKey:
      "pk_live_51KS4vmJhiOaVjc8SfBv4h85TzkqoINf4xz2puesVHlT3uccsj4DUbnxth6Uj6M3akUTrzee0lr7do1waNRyOjAnw00wVLieeBl",
    baseApiUrl: "https://api.myprotectall.com/post_sale_marketing/v1",
    stripeCheckoutApi: "/stripe_checkout",
    getOfferDetail: "/get_temp_cred",
    declineCoverage: "/user_opt_out",
    saveActivity: "/save_activity",
    getSecret: "/get-secret",
  },
};

export default configData[process.env.REACT_APP_STAGE];
